export default "__VITE_ASSET__83127973__"